// @ts-nocheck
import RootStore from "./RootStore";
import { CubaApp, getBasicAuthHeaders, initializeApp } from "@cuba-platform/rest";
import { CUBA_APP_URL } from "../../config";
import { readCookie } from "../util/cookieUtil";
import { makeFetchWrapper } from "./fetchExceptionWrapper";
import { MainStore } from "@cuba-platform/react";
import { $api } from "../shared/api";
import { EXCLUDE_METADATA_ROUTES } from "../routes/category/simple-pages";

const metadataEndpoints: Record<string, string> = {
  metadata: "/metadata/entities",
  messages: "/messages/entities",
  enums: "/metadata/enums",
};

const isMobile: boolean = window.innerWidth > 1024;

const DB_NAME = "cuba_metadata_cache";
const STORE_NAME = "metadata";
const CACHE_EXPIRATION_HOURS = 6; // Срок действия кеша

function openDB(): Promise<IDBDatabase> {
  return new Promise((resolve, reject) => {
    const request: IDBOpenDBRequest = indexedDB.open(DB_NAME, 1);
    request.onupgradeneeded = (event: IDBVersionChangeEvent) => {
      const db = (event.target as IDBOpenDBRequest).result;
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME);
      }
    };

    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
}

function saveToCache(data: any, key: string, etag: string): Promise<void> {
  return openDB().then(db => {
    return new Promise((resolve, reject) => {
      const transaction: IDBTransaction = db.transaction(STORE_NAME, "readwrite");
      const store: IDBObjectStore = transaction.objectStore(STORE_NAME);
      store.put({ data, etag }, key);
      transaction.oncomplete = () => resolve();
      transaction.onerror = () => reject(transaction.error);
    });
  });
}

function loadFromCache(key: string): Promise<{ data: any; etag?: string }> {
  return openDB().then(db => {
    return new Promise((resolve, reject) => {
      const transaction: IDBTransaction = db.transaction(STORE_NAME, "readonly");
      const store: IDBObjectStore = transaction.objectStore(STORE_NAME);
      const request = store.get(key);
      request.onsuccess = () => resolve(request.result || {});
      request.onerror = () => reject(request.error);
    });
  });
}

function clearCache(key: string): Promise<void> {
  return openDB().then(db => {
    return new Promise((resolve, reject) => {
      const transaction: IDBTransaction = db.transaction(STORE_NAME, "readwrite");
      const store: IDBObjectStore = transaction.objectStore(STORE_NAME);
      console.log("delete:", key);
      const request: IDBRequest = store.delete(key);
      request.onsuccess = () => resolve();
      request.onerror = () => reject(request.error);
    });
  });
}

const standardLoad = () => {
  CubaApp.prototype.loadMetadata = (): Promise<any[]> => {
    return new Promise(resolve => resolve([]));
  };
};


const loadMetadataWithCache = async (key: string, fetchOptions?: RequestInit) => {
  const { data, etag } = await loadFromCache(key);

  try {
    const res = await $api.get(metadataEndpoints[key], {
      params: { ...fetchOptions },
      headers: etag ? { "If-None-Match": etag } : {},
      validateStatus: (status) =>
        (status >= 200 && status < 300) || status === 304,
    });

    let finalData: any;

    if (res.status === 304) {
      finalData = data ?? (await standardLoad());
    } else {
      finalData = res.data;
      await saveToCache(finalData, key, res.headers["etag"]);
    }

    mainStore[key] = finalData;
    return finalData;
  } catch (e) {
    console.log("error when loading metadata");
    console.error(e);

    if (!data) return standardLoad();
    return data;
  }
};

const metadataLoaders: Record<keyof typeof metadataEndpoints, string> = {
  metadata: "loadMetadata",
  messages: "loadEntitiesMessages",
  enums: "loadEnums",
};

const registerMetadataLoaders = () => {
  Object.entries(metadataLoaders).forEach(([key, methodName]) => {
    (CubaApp.prototype as any)[methodName] = async function(fetchOptions?: RequestInit): Promise<any> {
      return await loadMetadataWithCache(key as keyof typeof metadataEndpoints, fetchOptions);
    };
  });
};

const hash = window.location.hash;

if (!EXCLUDE_METADATA_ROUTES.some(excluded => hash.includes(excluded))) {
  console.log("page-with-metadata");
  registerMetadataLoaders();
}

if (
  EXCLUDE_METADATA_ROUTES.some(
    excluded => hash.includes(excluded) && hash.includes("mobile-auth"),
  )
) {
  console.log("page-without-metadata");
  (CubaApp.prototype as any).loadMetadata = (): Promise<any[]> => Promise.resolve([]);
  (CubaApp.prototype as any).loadEntitiesMessages = (): Promise<any[]> => Promise.resolve([]);
  // (CubaApp.prototype as any).loadEnums = (): Promise<any[]> => Promise.resolve([]);
}


export const cubaREST = initializeApp({
  name: "kzm",
  apiUrl: CUBA_APP_URL,
  storage: window.localStorage,
  // restClientId: 'tsadv-XHTr0e8J',
  // restClientSecret: "0d2d8d1f1402d357f27aaf63cd5411224ea8e3c3a326172270de6e249ce6c54c"
  restClientId: "tsadv-XHTr0e8J",
  restClientSecret: "0d2d8d1f1402d357f27aaf63cd5411224ea8e3c3a326172270de6e249ce6c54c",
});

makeFetchWrapper();

// NOTE: Read token from cookie when user is loged in using SSO
readCookie(cubaREST);

export type RootStoreProp = {
  rootStore?: RootStore;
}

cubaREST.login = function(login, password, options) {
  if (login == null) {
    login = "";
  }


  if (password == null) {
    password = "";
  }

  const fetchOptions = {
    method: "POST",
    headers: getBasicAuthHeaders(this.restClientId, this.restClientSecret, this.locale),
    body: "grant_type=password&username=" + encodeURIComponent(login) + "&password=" + encodeURIComponent(password),
  };
  const endpoint = options && options.tokenEndpoint ? options.tokenEndpoint : "v2/oauth/token";
  const { checkStatus } = (cubaREST as any);
  const loginRes = fetch(this.apiUrl + endpoint, fetchOptions)
    .then(checkStatus)
    .then(function(resp) {
      return resp.json();
    })
    .then(function(data) {
      cubaREST.restApiToken = data.access_token;
      return data;
    });
  return loginRes;
};

export const rootStore = new RootStore(cubaREST);

export const mainStore = new MainStore(cubaREST);
